import * as React from 'react';
import {useNavigate} from 'react-router-dom';
import {ShoppingBag} from 'lucide-react';
import {useCart} from '../cart';

// Navbar shortcut to the rental request, with a count of items in it.
const CartBadge: React.FC = () => {
    const cart = useCart();
    const navigate = useNavigate();
    if (cart.items.length === 0) return null;
    return (
        <button onClick={() => navigate('/book')} title="Your rental request"
                className="relative inline-flex items-center justify-center h-9 w-9 text-gray-300 border border-gray-700 rounded hover:border-lumina-accent hover:text-white transition-colors">
            <ShoppingBag className="w-4 h-4"/>
            <span className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] px-1 rounded-full bg-lumina-accent text-black text-[10px] font-bold flex items-center justify-center">
                {cart.items.length}
            </span>
        </button>
    );
};

export default CartBadge;
